import { render, staticRenderFns } from "./FlowItems.vue?vue&type=template&id=70c196a8&scoped=true&"
import script from "./FlowItems.vue?vue&type=script&lang=js&"
export * from "./FlowItems.vue?vue&type=script&lang=js&"
import style0 from "./FlowItems.vue?vue&type=style&index=0&id=70c196a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c196a8",
  null
  
)

export default component.exports